import ApplicationSerializer from 'eflex/serializers/application';

export default class KineticConfigKineticSerializer extends ApplicationSerializer {
  attrs = {
    bom: {
      embedded: 'always',
    },
  };
}
